module.exports = __webpack_public_path__ + "static/on-writing-6a07553af36c6074f3e1db7d65747dbc.jpg";